export const EVENT_ORDER = window.EVENT_ORDER;
/**
 * @constant {Object} - Исходный объект заказа полученный из сервера
 * {
 *   id,
 *   carts {Array} - [{ event_id, ... }, ... ]
 * }
 */
export const INITIAL_EVENT_ORDER = window.INITIAL_EVENT_ORDER;

export const DEFAULT_ICON_URL = '/images/site/default-photo.svg';
export const TEAM_ICON_URL = '/images/site/logo-lenta.svg';
